import landscapeCarousel from 'components/landscapeCarousel';
import spotlightTpl from 'templates/carousels/__carouselSpotlight.tpl';
import { SpotlightDefaultBreakpointRules } from 'components/settings/BreakpointSettings';
import Countdown from 'components/countdown';
import WatchlistCta from '../components/watchlist/WatchlistCta';
import PreferencesCta from '../components/preferences/PreferencesCta';
import { trackAction } from 'helpers/trackingOM';
import { formatSpotlightTime } from 'helpers/dates';
import appendSpotlightTracking from './helpers/spotlightTracking';
import { KIDS, YOUNGER_KIDS } from 'helpers/ProfileConstants';
import { checkAutoplayCapabilities } from 'components/videoPreview/videoPreviewCapabilities';
import VideoPreview from 'components/videoPreview/videoPreview';
import {
    VideoPreviewEvent,
    LocalStorageName,
} from '../components/videoPreview/videoPreviewConstants';

export default function spotlightCarousel($wrapper, carouselData) {
    const $carouselElement = $wrapper.find('.js-video-carousel');
    const numPaginationToShow = 5;
    const disabledPaginationIndex = numPaginationToShow + 1;
    const isKidsProfile =
        CBS?.Registry?.user?.profile_type === KIDS ||
        CBS?.Registry?.user?.profile_type === YOUNGER_KIDS;
    let $spotlightWrapperElement = null;
    let spotlightWrapperElement = null;
    let isExpandedCarouselVideoPlaying = false;
    let isSlideChangeAnimating = false;

    try {
        return {
            wrapper: $carouselElement,
            init: function () {
                const options = {
                    endPoint: carouselData.baseEndpoint,
                    template: spotlightTpl,
                    responsive: SpotlightDefaultBreakpointRules,
                    numPaginationToShow: numPaginationToShow,
                    disabledPaginationIndex: disabledPaginationIndex,
                    autoplay: {
                        delay: 10000,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: false,
                    },
                    params: {
                        slug: $wrapper.data('slug'),
                        sectionId: $wrapper.data('sectionid'),
                    },
                    on: {
                        afterInit: function () {
                            const swiper = this;
                            // next arrow click
                            swiper?.el
                                ?.querySelector('.spotlight-carousel-next')
                                .addEventListener('click', () => {
                                    if (isSlideChangeAnimating === true) {
                                        return false;
                                    }

                                    // tracking
                                    trackAction(
                                        'trackPostersArrowSelect',
                                        appendSpotlightTracking($wrapper),
                                    );

                                    // progress forward and loop
                                    if (swiper.isEnd) {
                                        swiper.slideTo(0);
                                    } else {
                                        swiper.slideNext();
                                    }
                                });

                            setTimeout(function () {
                                // pagination bullet poster click
                                const bullets = swiper?.el?.querySelectorAll(
                                    'span.swiper-pagination-bullet',
                                );
                                bullets.forEach(function (bullet, index) {
                                    bullet.addEventListener('click', () => {
                                        // wait for active slide to become visible and do tracking call
                                        setTimeout(() => {
                                            trackAction(
                                                'trackPosterSelect',
                                                appendSpotlightTracking($wrapper, {}),
                                            );
                                        }, 500);
                                    });
                                });
                            }, 10);

                            initSpotlightSlideEvents();
                        },
                        slideChange: function () {
                            const swiper = this;
                            const lastBulletIndex = swiper.pagination.bullets.length - 1;
                            const paginationWrapper = swiper?.el?.querySelector(
                                '.swiper-pagination-wrapper',
                            );
                            const pagination =
                                paginationWrapper?.querySelector('.swiper-pagination');
                            const bullets = pagination?.querySelectorAll(
                                'span.swiper-pagination-bullet',
                            );
                            const winWidth = this._isSafari
                                ? $(window).width()
                                : $(window).outerWidth();
                            const isDesktop = winWidth >= 1024;
                            let fadingBulletClone = null;

                            // shift left if progressing to disabledPaginationIndex
                            if (
                                bullets[swiper.activeIndex].classList.contains('disabled') &&
                                isDesktop
                            ) {
                                bullets.forEach(function (bullet) {
                                    const newIndex =
                                        parseInt(
                                            window
                                                ?.getComputedStyle(bullet)
                                                ?.getPropertyValue('order'),
                                        ) - 1;
                                    const order = newIndex === -1 ? lastBulletIndex : newIndex;

                                    // update flex order
                                    bullet.style.order = order;

                                    // reset classes
                                    bullet.classList.remove('fading', 'hide', 'show', 'disabled');

                                    // hack to trigger reflow (so css animation doesn't get optimized out by browser)
                                    void bullet.offsetWidth;

                                    if (order === 0) {
                                        // fade out first slide
                                        bullet.classList.add('fading', 'disabled');
                                        // if exactly numPaginationToShow slides
                                        if (lastBulletIndex === numPaginationToShow) {
                                            // block ui until animation complete
                                            isSlideChangeAnimating = true;
                                            // clone the fadeout one and slap it on the end
                                            fadingBulletClone = bullet.cloneNode(true);
                                            fadingBulletClone.classList.add('disabled', 'show');
                                            fadingBulletClone.classList.remove('fading');
                                            fadingBulletClone.style.order =
                                                swiper.pagination.bullets.length;
                                            pagination.appendChild(fadingBulletClone);

                                            // wait for animation
                                            setTimeout(function () {
                                                isSlideChangeAnimating = false;
                                                // clean up fading clone
                                                fadingBulletClone.remove();
                                                const fadingBullet = swiper?.el?.querySelector(
                                                    'span.swiper-pagination-bullet.fading',
                                                );
                                                if (fadingBullet) {
                                                    fadingBullet.classList.remove('fading');
                                                    if (
                                                        bullets.length !== disabledPaginationIndex
                                                    ) {
                                                        fadingBullet.classList.add('hide');
                                                    }
                                                    fadingBullet.style.order =
                                                        swiper.pagination.bullets.length;
                                                }
                                            }, 400);
                                        }
                                    } else if (order === disabledPaginationIndex) {
                                        // set disabled slide
                                        bullet.classList.add('disabled', 'show');
                                    } else if (order > disabledPaginationIndex) {
                                        // hide extra slides past disabledPaginationIndex
                                        bullet.classList.add('hide');
                                    } else {
                                        // show all other slides
                                        bullet.classList.add('show');
                                    }
                                });
                            }

                            initSpotlightSlideEvents();
                        },
                        resize: function () {
                            const swiper = this;
                            swiper.update();
                            positionBottomContent(this?.el?.querySelector('.bottom-right-content'));
                        },
                    },
                };

                landscapeCarousel({
                    parentContainer: $carouselElement,
                    options: options,
                });

                $wrapper.on('init', () => spotlightWrapperInit());
            },
        };
    } catch (e) {
        console.log(e);
    }

    function getCurrentUninitializedSlide() {
        const $el = $wrapper.find('.swiper-slide-visible:not(.spotlight-initialized)');
        return $el?.length ? $el : $();
    }

    function initSpotlightSlideEvents() {
        setTimeout(() => {
            initCountdown();
            initWatchListCTA();
            initPreferencesCTA();
            initDate();
            initBackgroundVideo();
            initWatchNowCTAClick();
            detailsCTAClick();
            const $el = getCurrentUninitializedSlide();
            $el?.addClass('spotlight-initialized');
        }, 10);
    }

    function spotlightWrapperInit() {
        $carouselElement.removeClass('hidden');
        const observer = new MutationObserver(function () {
            $spotlightWrapperElement = $wrapper.find('.spotlight-carousel-wrapper');
            if ($spotlightWrapperElement?.length) {
                spotlightWrapperElement = $spotlightWrapperElement[0];
                observer.disconnect();
            }
        });
        observer.observe(document, {
            attributes: false,
            childList: true,
            characterData: false,
            subtree: true,
        });
    }

    async function handleCarouselVideoStart(player, spotlightBackgroundVideo, muteToggleButton) {
        isExpandedCarouselVideoPlaying = true;
        if (spotlightBackgroundVideo?.classList.contains('show')) {
            setVideoMuteState(player, muteToggleButton);
            try {
                await player?.pause();
            } catch (e) {
                console.error('Spotlight video pause() error', e);
            }
        }
    }

    async function handleCarouselVideoStop(player, spotlightBackgroundVideo, muteToggleButton) {
        isExpandedCarouselVideoPlaying = false;
        if (spotlightBackgroundVideo?.classList.contains('show')) {
            setVideoMuteState(player, muteToggleButton);
            try {
                await player?.play();
            } catch (e) {
                console.error('Spotlight video play() error', e);
            }
        }
    }

    function initCountdown() {
        const $el = getCurrentUninitializedSlide();
        const $countdownElement = $el.find('.spotlight-countdown');
        if ($countdownElement.length > 0) {
            new Countdown($countdownElement[0]);
        }
    }

    function initWatchListCTA() {
        const $el = getCurrentUninitializedSlide();
        const $watchListCTAElement = $el.find('.watchlist_wrapper');
        const watchlistEnabled = CBS?.Registry?.Features?.watchlist_enabled;
        if (watchlistEnabled && $watchListCTAElement.length > 0) {
            try {
                new WatchlistCta($el[0]);
            } catch (e) {
                console.error('Watchlist cta failed to load', e);
            }
        }
    }

    function initPreferencesCTA() {
        const $el = getCurrentUninitializedSlide();
        const $preferenceCTAElement = $el.find('.content_preference_wrapper');
        const preferencesEnabled =
            CBS?.Registry?.Features?.content_preferences_enabled && !isKidsProfile;
        if (preferencesEnabled && $preferenceCTAElement.length > 0) {
            try {
                new PreferencesCta($el[0]);
            } catch (e) {
                console.error('Preferences cta failed to load', e);
            }
        }
    }

    function initDate() {
        const $el = getCurrentUninitializedSlide();
        const $airDate = $el?.find('.air-date');
        if ($airDate.length > 0) {
            const streamStartDate = $airDate.data('stream-start-timestamp');
            const streamEndDate = $airDate.data('stream-end-timestamp');
            const startDate = $airDate.data('start-timestamp');
            const endDate = $airDate.data('end-timestamp');
            if (
                streamStartDate &&
                streamEndDate &&
                startDate &&
                endDate &&
                typeof formatSpotlightTime === 'function'
            ) {
                $airDate.html(
                    formatSpotlightTime(streamStartDate, streamEndDate, startDate, endDate),
                );
            }
        }
    }

    function showSpotlightBackgroundVideo(spotlightBackgroundVideo, muteToggleButton) {
        // pause all videos except for current one
        const videoContainers = document.querySelectorAll(
            '.spotlight-background-video, .marqueeVideo',
        );
        if (videoContainers) {
            try {
                videoContainers.forEach((videoContainer) => {
                    if (videoContainer !== spotlightBackgroundVideo) {
                        const video = videoContainer?.querySelector('video');
                        if (video) {
                            video?.pause();
                        }
                    }
                });
            } catch (e) {
                console.error('Spotlight error pausing videos', e);
            }
        }

        spotlightBackgroundVideo?.classList.add('show');
        muteToggleButton?.classList.add('show');
    }

    function hideSpotlightBackgroundVideo(spotlightBackgroundVideo, muteToggleButton) {
        spotlightBackgroundVideo?.classList.remove('show');
        muteToggleButton?.classList.remove('show');
    }

    function setVideoMuteState(player, muteToggleButton) {
        const spliceVolumeOn = localStorage.getItem(LocalStorageName.VOLUME_ON);
        try {
            if (spliceVolumeOn === '1') {
                player?.mute(false);
                muteToggleButton?.classList.remove('muted');
                muteToggleButton?.setAttribute('title', 'Mute Audio');
            } else {
                player?.mute(true);
                muteToggleButton?.classList.add('muted');
                muteToggleButton?.setAttribute('title', 'Unmute Audio');
            }
        } catch (e) {
            console.error('Spotlight video mute() error', e);
        }
    }

    async function initBackgroundVideo() {
        const $el = getCurrentUninitializedSlide();
        const videoPreviewUrl = $el.find('.spotlight-carousel-wrapper').data('videoPreviewUrl');
        const spotlightBackgroundVideo = $el[0]?.querySelector('.spotlight-background-video');
        const videoPreviewUrlIsValidResponse = await fetch(videoPreviewUrl, { method: 'HEAD' });

        if (!videoPreviewUrlIsValidResponse?.ok || !videoPreviewUrl || !spotlightBackgroundVideo) {
            $wrapper.find('.swiper-container')[0]?.swiper?.autoplay?.start();
            return;
        }

        const muteToggleButton = $el[0].querySelector('.hero-volume');

        let videoHasEnded = false;
        let videoHasStarted = false;

        await checkAutoplayCapabilities();
        const spliceVolumeOn = localStorage.getItem(LocalStorageName.VOLUME_ON) === '1';

        const player = new VideoPreview({
            id: spotlightBackgroundVideo.id,
            selector: '#' + spotlightBackgroundVideo.id,
            mediaUrl: videoPreviewUrl,
            delayStart: 0,
            destroyAfterPlay: false,
            mutedAutoplay: !spliceVolumeOn,
        });

        const intersectionObserverOptions = {
            root: null,
            rootMargin: '0px',
            threshold: 1,
        };
        let playTimeoutId = null;
        let hasPlayed = false;

        player?.addEventListener(VideoPreviewEvent.ENDED, (e) => {
            hideSpotlightBackgroundVideo(spotlightBackgroundVideo, muteToggleButton);
            trackVideoPreview($el, 'trackVideoPreviewEnd', e.detail?.contentTime);
            $wrapper.find('.swiper-container')[0]?.swiper?.autoplay?.start();
            videoHasEnded = true;
        });

        document.body.addEventListener('carouselVideoStart', () => {
            handleCarouselVideoStart(player, spotlightBackgroundVideo, muteToggleButton);
        });
        document.body.addEventListener('carouselVideoStop', () => {
            handleCarouselVideoStop(player, spotlightBackgroundVideo, muteToggleButton);
        });

        const $link = $el.find('.link');
        if ($link.length > 0) {
            $link.on('click', () => {
                trackVideoPreview($el, 'trackVideoPreviewEnd');
            });
        }

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(async (entry) => {
                // spotlight in viewport
                if (entry.isIntersecting && !isExpandedCarouselVideoPlaying) {
                    playTimeoutId = setTimeout(async () => {
                        try {
                            $wrapper.find('.swiper-container')[0].swiper?.autoplay?.stop();
                            player?.seek(0);
                            if (!videoHasStarted) {
                                await player?.setPlayer();
                                videoHasStarted = true;
                            } else if (videoHasEnded) {
                                await player?.replay();
                                videoHasEnded = false;
                            } else {
                                player?.resumePlayback();
                            }
                            showSpotlightBackgroundVideo(
                                spotlightBackgroundVideo,
                                muteToggleButton,
                            );
                            setVideoMuteState(player, muteToggleButton);
                            trackVideoPreview($el, 'trackVideoPreviewStart');
                            playTimeoutId = null;
                            hasPlayed = true;
                        } catch (error) {
                            console.log('Spotlight video play/resume error', error);
                            $wrapper.find('.swiper-container')[0].swiper?.autoplay?.start();
                        }
                    }, 1000);
                } else {
                    if (hasPlayed) {
                        try {
                            if (player.getPlaybackState() === 'waiting') {
                                player.once(
                                    VideoPreviewEvent.PLAYBACK_STATE_CHANGE,
                                    player.suspendPlayback.bind(player),
                                );
                            } else {
                                player.suspendPlayback();
                            }
                            if (!videoHasEnded) {
                                trackVideoPreview($el, 'trackVideoPreviewEnd');
                            }
                        } catch (error) {
                            console.log('Spotlight video suspend error', error);
                        }
                    } else if (playTimeoutId) {
                        clearTimeout(playTimeoutId);
                        playTimeoutId = null;
                    }
                    hideSpotlightBackgroundVideo(spotlightBackgroundVideo, muteToggleButton);
                    clearTimeout(playTimeoutId);
                    hasPlayed = false;
                }
            });
        }, intersectionObserverOptions);
        observer.observe(spotlightBackgroundVideo);
        initMuteToggle(player, muteToggleButton);
    }

    function initMuteToggle(player, muteToggleButton) {
        if (!player || !muteToggleButton) {
            return;
        }
        muteToggleButton.addEventListener('click', async (ev) => {
            const currentTarget = ev.currentTarget;
            try {
                if (currentTarget.classList.contains('muted')) {
                    player.mute(false);
                    currentTarget.classList.remove('muted');
                    currentTarget.setAttribute('title', 'Mute Audio');
                    localStorage.setItem(LocalStorageName.VOLUME_ON, 1);
                } else {
                    player.mute(true);
                    currentTarget.classList.add('muted');
                    currentTarget.setAttribute('title', 'Unmute Audio');
                    localStorage.setItem(LocalStorageName.VOLUME_ON, 0);
                }
            } catch (e) {
                console.error('Spotlight video mute() error', e);
            }
            if (player.isPaused()) {
                try {
                    player?.play();
                } catch (e) {
                    console.error('Spotlight video play() error', e);
                }
            }
        });

        positionBottomContent();
    }

    function positionBottomContent() {
        const $pagination = $wrapper.find('.swiper-pagination');
        if ($pagination.html() !== '') {
            const $visibleSlide = $wrapper.find('.swiper-slide-visible');
            const $bottomRightContent = $visibleSlide.find('.bottom-right-content');
            const paginationHeight = $pagination.height();
            $bottomRightContent.css('bottom', paginationHeight + 62);
            $bottomRightContent.addClass('hide-logo');
        }
    }

    function initWatchNowCTAClick() {
        const $el = getCurrentUninitializedSlide();
        const $watchNowCTA = $el.find('.spotlight-button--live');
        // if empty href, reach out to api again and check for actionUrl
        if ($watchNowCTA.length > 0 && $watchNowCTA.attr('href') === '') {
            const carouselEndpoint =
                carouselData.regionPrefix +
                '/carousels/homepage/configItems/' +
                carouselData.userState +
                '/' +
                encodeURIComponent(carouselData.token) +
                '/offset/{offset}/limit/{limit}/';
            $watchNowCTA.on('click', (e) => {
                e.preventDefault();
                $.ajax({
                    url: carouselEndpoint,
                    type: 'POST',
                    dataType: 'json',
                    success: function (resp) {
                        // redirect to the latest actionUrl
                        if (
                            resp?.result?.data[0]?.actionUrl &&
                            resp.result.data[0].actionUrl !== ''
                        ) {
                            redirectToUrl(resp.result.data[0].actionUrl);
                        } else {
                            redirectToDetailsPage($el);
                        }
                    },
                    error: function () {
                        redirectToDetailsPage($el);
                    },
                });
            });
        }
    }

    function detailsCTAClick() {
        const $el = getCurrentUninitializedSlide();
        const $detailsCTA = $el.find('.detailsCta');
        if ($detailsCTA.length > 0) {
            $detailsCTA.on('click', () => {
                trackAction('trackMoreInfoSelect', appendSpotlightTracking($wrapper));
            });
        }
    }

    function redirectToUrl(url) {
        if (url) {
            window.location.href = url;
        }
    }

    function redirectToDetailsPage($el) {
        // redirect to existing details page url
        const detailsCtaHref = $el.find('.spotlight-button--details').attr('href');
        if (detailsCtaHref) {
            redirectToUrl(detailsCtaHref);
        }
    }

    function trackVideoPreview($el, action, contentTime = null) {
        const aaLinkData = $el.find('.spotlight-link').attr('aa-link').split('|');
        const video = $el.find('.spotlight-background-video video')[0] ?? null;
        const elapsedTime = Math.trunc(contentTime ?? video?.currentTime).toString() ?? '0';
        const trackingObj = {
            elapsedTime: elapsedTime ?? '',
            contentLocked: aaLinkData[17],
        };
        trackAction(action, appendSpotlightTracking($wrapper, trackingObj));
    }
}
